export default __webpack_public_path__ + "static/media/Ingrid_900.13d9d7cd.webp";